export const clinicalInfoQueryKey = (patientUuid: string) =>
  ['camel', 'patient_profile', 'clinical_info', patientUuid] as const;
